import React from "react";
import "../lib/index.css";

export function Checkbox({isChecked, children, checkBoxAction}:Checkbox) {
    return (
        <div>
            <label className="checkbox-main__label" style={{alignItems: 'center'}}>
                <input type="checkbox" className="checkbox-main__input" checked={isChecked} onChange={() => checkBoxAction()}/>
                    <span className="checkbox-main__span"></span>
                    {children}
            </label>
        </div>
    )
}